import { render } from "./ClienteObligados.vue?vue&type=template&id=f48027d8"
import script from "./ClienteObligados.vue?vue&type=script&lang=js"
export * from "./ClienteObligados.vue?vue&type=script&lang=js"

import exportComponent from "/home/ubuntu/Proyectos/Vue/cotizador-ventus/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__